import { render, staticRenderFns } from "./detail-comparing-journal.vue?vue&type=template&id=9d3cf0c8&scoped=true"
import script from "./detail-comparing-journal.vue?vue&type=script&lang=js"
export * from "./detail-comparing-journal.vue?vue&type=script&lang=js"
import style0 from "./detail-comparing-journal.vue?vue&type=style&index=0&id=9d3cf0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3cf0c8",
  null
  
)

export default component.exports